import { AirportDialSettings } from '@mono/types/src/weather-widgets/airport-dial-settings';

export const defaultAirportDialSettings: AirportDialSettings = {
    title: 'Runway Wind Dial',
    displayTable: true,
    units: 'kts',
    runwayAngle: 0,
    mode: 'cozy',
};
